module.exports = __webpack_public_path__ + "media/wave_solder_pallets/top-hat-96e8f0fd.png";